import { render, staticRenderFns } from "./ProgramGroup.vue?vue&type=template&id=07f66910"
import script from "./ProgramGroup.vue?vue&type=script&lang=ts"
export * from "./ProgramGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports